import React, { forwardRef } from 'react';

const Modal = forwardRef(({ isOpen, onClose, children }, ref) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" ref={ref}>
        {children}
      </div>
    </div>
  );
});

export default Modal;
